import { OrderStatus } from 'Components/constants/PandaConstants';
import React, { useEffect } from 'react'
import { PayPalButton } from "react-paypal-button-v2";

type Props = {
    callBack: any,
    amount: any,
    clientId: any,
    createPaymentLog: any
}

function PaypalPayment({ callBack, amount, clientId, createPaymentLog }: Props) {

    const payment = async (status, paymentID, data) => {
        if (status == "COMPLETED") {
            await createPaymentLog(`Payment has been completed. User has done the payment through ${data.paymentSource}`,OrderStatus.PaymentCompleted,"","",paymentID);
            callBack(paymentID, false);
        }
    }

    useEffect(() => {
        createPaymentLog('PayPal has been initiated',OrderStatus.PaymentInitidated);
    },[]);

    return (
        <div className="container-fluid">
            <div>
                <PayPalButton
                    amount={amount}
                    shippingPreference='NO_SHIPPING'
                    onSuccess={(details, data) => {
                        payment(details.status, data.paymentID, data)
                    }}
                    options={{
                        clientId: clientId,
                    }}
                />
            </div>
        </div>
    )
}

export default PaypalPayment